<template>
  <div id="landings-list">
    <SidebarLayout2
      :breadcrumb="breadcrumbs"
      pageTitle="Crie Coleções de hotéis para exibir no site"
    >
      <template #sidebar>
        <div class="sidebar">
          <Heading class="sidebar--title">
            Ações da página
          </Heading>
          <span class="sidebar--button">
            <Button
              :hasIcon="true"
              class="sidebar--button__log"
              @click="$router.push({ path: '/landings/criar' })"
            >
              Criar nova coleção
            </Button>
            <Button
              :disabled="selectedRows.length !== 1"
              class="sidebar--button__edit"
              @click="
                $router.push({
                  path: `/landings/editar/${selectedRows[0].id}`
                })
              "
            >
              Editar
            </Button>
            <Button
              :disabled="selectedRows.length === 0"
              variation="error"
              class="sidebar--button__delete"
              @click="showModal = true"
            >
              Excluir
            </Button>
          </span>
          <Heading class="sidebar--tip-title">
            Dica
          </Heading>
          <Paragraph class="sidebar--tip-text">
            Crie Coleções de Hotéis para personalizar a exibição de suas
            propriedades no site Letsbook. <br /><br />
            Exemplo: Utilize essas coleções para destacar hotéis em landings
            promocionais ou para organizar listagens por destino, oferecendo uma
            experiência de navegação otimizada aos seus clientes.
          </Paragraph>
        </div>
      </template>

      <template #content>
        <div class="filters">
          <SearchInput
            v-model="filterByName"
            placeholder="Buscar por nome de coleção"
            class="filters--item filters--item__search"
          />

          <!-- HOTEL -->
          <PmwFilterDropdown
            v-model="filterByHotels"
            :options="hotelOptions"
            :radioOptions="false"
            label="Hotéis"
            class="filters--item"
            hasSearch
          />
        </div>

        <DataTable
          :cols="columns"
          :colsMinWidths="colsMinWidths"
          :isLoading="false"
          :rows="filterList"
          :selectableRow="true"
          class="data-table"
          ref="dataTable"
          @getSelectedRows="selectedRows = $event"
        >
          <template v-slot:acoes="slotProps">
            <button
              class="data-table--action"
              @click.stop.prevent="
                $router.push({
                  path: `/landings/editar/${slotProps.rowDataObj.id}`
                })
              "
            >
              Editar
            </button>
          </template>
          <template v-slot:excluir="slotProps">
            <button
              class="data-table--action__delete"
              @click.stop.prevent="deleteModal(slotProps.rowDataObj.id)"
            >
              Excluir
            </button>
          </template>
        </DataTable>
        <AlertModal
          v-model="showModal"
          :buttonClose="true"
          icon="trash-can"
          title="Excluir agrupador de hotéis"
          @alert-modal-confirm="deleteLanding"
        >
          <template #text>
            Ao excluir um grupo de hotéis que pode estar sendo utilizado em
            algum site a integração será afetada. <br />
            Tem certeza que quer fazer isso?
          </template>
        </AlertModal>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import PmwFilterDropdown from '@solucoes/components-lib-tmp/src/components/patterns/PmwFilterDropdown'
import SidebarLayout2 from '@/layouts/SidebarLayout2'

export default {
  name: 'LandingsList',

  components: {
    AlertModal,
    Button,
    DataTable,
    Heading,
    Paragraph,
    SearchInput,
    SidebarLayout2,
    PmwFilterDropdown
  },

  data() {
    return {
      /** Caminho de pão */
      breadcrumbs: [
        {
          label: 'Site Let’s Book'
        },
        {
          label: 'Coleções de hotéis',
          url: '/'
        }
      ],

      /** Colunas da tabela */
      columns: [
        {
          name: 'nome',
          alias: 'Nome da coleção'
        },
        {
          name: 'acoes',
          alias: 'Ações'
        },
        {
          name: 'excluir'
        }
      ],

      /** Largura mínima das colunas */
      colsMinWidths: {
        acoes: '0px',
        excluir: '0px'
      },

      /** Filtro por nome (v-model) */
      filterByName: '',

      /** Filtro por hotéis */
      filterByHotels: [],

      /** Listagem de hotéis */
      hotelOptions: [],

      /** Dados da tabela (linhas) */
      listData: [],

      /** Linhas selecionadas */
      oneSelectedRow: [],

      selectedRows: [],

      /** Visualização da modal */
      showModal: false
    }
  },

  computed: {
    /** Filtra a lista pelo nome da landing */
    filterList() {
      const filterByName = this.listData.filter((item) =>
        item.data.nome.toLowerCase().includes(this.filterByName.toLowerCase())
      )

      const hotels = this.filterByHotels.map((filterHotel) => filterHotel.value)

      if (hotels.length) {
        return filterByName.filter((item) =>
          item.data?.hoteis?.some((hotelId) => hotels.includes(hotelId))
        )
      } else return filterByName
    }
  },

  created() {
    this.getLandings()

    this.getHotels()
  },

  methods: {
    /** Busca a lista de hotéis para o filtro */
    getHotels() {
      this.$initialSetting.getHotels().then((response) => {
        const data = response.data

        const sorted = data.slice().sort((a, b) => b?.ativo - a?.ativo)

        this.hotelOptions = sorted.map((item) => ({
          value: item.codigo,
          label: item.ativo ? item.nome : `${item.nome} - (inativo)`
        }))
      })
    },

    /** Limpa as seleções na tabela */
    clearSelectedRows() {
      this.selectedRows = [] /** Limpa array de itens selecionados na tabela */
      this.oneSelectedRow = []
      this.$refs.dataTable.selectAllRows()
    },

    /** Exclui itens */
    deleteLanding() {
      let ids = null
      /** Se for exclusão pelo botão da sidebar */
      if (this.oneSelectedRow.length === 0) {
        ids = this.selectedRows.map((item) => {
          return item.id
        })
        /** Se for exclusão pela coluna da tabela */
      } else {
        ids = this.oneSelectedRow
      }
      this.$landings
        .deleteLanding({ landings: ids })
        .then(() => {
          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Grupo de hotéis excluído'
          })
          this.getLandings()
          this.clearSelectedRows()
        })
        .catch(() => {
          /** Feedback de erro */
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao excluir'
          })
        })
    },

    /**
     * Modal de deleção
     * @param {Number|String} id: Id da landing
     */
    deleteModal(id) {
      this.showModal = true
      if (id) {
        this.oneSelectedRow.push(id)
      }
    },

    /**
     * Formata os dados vindos do back para o formato da lista
     * @param {Array} data: Lista de Landings do backend
     */
    formatLandingsData(data) {
      const array = []
      data.forEach((item) => {
        array.push({
          data: {
            id: item.codigo,
            nome: item.nome,
            hoteis: item.hoteis.map((hotel) => hotel.codigo)
          }
        })
      })
      return array
    },

    /** Traz a lista de landings */
    getLandings() {
      this.$landings.getLandings().then((response) => {
        this.listData = this.formatLandingsData(response.data)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}

::v-deep {
  .pmw-td span {
    font-size: font-size('size-small');
  }

  .pmw-col.pmw-th:nth-child(3),
  .pmw-col.pmw-td:nth-child(3) {
    max-width: 80px;
  }

  .pmw-col.pmw-th:nth-child(3) {
    border-right: none;
  }

  .pmw-col.pmw-th:nth-child(4),
  .pmw-col.pmw-td:nth-child(4) {
    max-width: 70px;
  }

  .pmw-col.pmw-th:nth-child(3),
  .pmw-col.pmw-th:nth-child(4) {
    pointer-events: none;
    .pmw-sort-icons {
      display: none;
    }
  }

  .content {
    .page-heading {
      padding-bottom: 32px;
    }
  }

  .pmw-filter-dropdown {
    .pmw-dropdown--options {
      max-height: 260px;
    }

    .pmw-input-checkbox {
      &--fakebox {
        .pmw-icon {
          color: pmw-colors('blue-100');
        }
      }

      input {
        &:checked ~ .pmw-input-checkbox--fakebox {
          background-color: pmw-colors('blue-100');
          border: 1px solid pmw-colors('blue-100');
        }
      }
    }

    .pmw-dropdown--trigger-button {
      background-color: $pmw-white;

      &:active,
      &[aria-expanded='true'] {
        color: pmw-colors('grey-90');
        background-color: $pmw-white;
      }
    }
  }
}

.sidebar {
  max-width: 215px;
  padding-top: 35px;
  margin-left: 15px;

  &--title {
    margin-bottom: 10px;
  }

  &--button {
    display: flex;
    gap: 10px;
    flex-direction: column;
    margin-bottom: 35px;
  }

  &--tip-text {
    line-height: 21px;
  }
}

.filters {
  &--item {
    margin-bottom: 32px;

    &__search {
      width: 245px;
    }
  }
}

.data-table {
  &--action {
    border: none;
    background-color: inherit;
    color: $primary;
    font-weight: font-weight('weight-medium');

    &__delete {
      border: none;
      background-color: inherit;
      color: $red-2;
      font-weight: font-weight('weight-medium');
    }
  }
}
</style>
